import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion',
  template: `
    <div class="accordion-container">
      <ng-content select="app-accordion-item"></ng-content>
    </div>
  `,
  styleUrls: ['./accordion.component.sass'],
  standalone: true,
  imports: []
})
export class AccordionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
